import React from 'react';
import { AppFontIcon, AppText } from '@frontend-modules/ui-kit';
import { OnlineLessonTag } from '@fsd-entities/online-lessons/ui/OnlineLessonTag';
import { MeetingEnterButton } from '@fsd-features/online-lessons/EnterToOnlineLesson';
import { getUserName } from '@fsd-shared/utils';
import { E_COLORS } from 'src-new/constants';

import { INotificationCardProps } from './NotificationCard.types';

import './NotificationCard.style.scss';
export const NotificationCard: React.FC<INotificationCardProps> = (props) => {
    const { data, isCollapsed = false, isMeetingStarted = false, handleCollapseBtnClick } = props;
    const { title, tags, url, type, users, description, canHide } = data;

    return (
        <div className={`notification-card ${isCollapsed && 'collapsed'}`}>
            {isCollapsed && <div className={`pulse-circle ${isMeetingStarted && 'warning'}`} />}
            <div className={`notification-card__closed-title ${!isCollapsed && 'hidden'}`}>
                <OnlineLessonTag type={type} isIconView={isCollapsed} />
                <div className={`notification-card__closed-title_nowrap`}>
                    <AppText text={title} textStyle={'DesktopH3'} />
                </div>
            </div>
            <div className={`notification-card__header ${isCollapsed && 'hidden'}`}>
                <div className={'notification-card__header_tags'}>
                    <OnlineLessonTag type={type} />
                    {tags?.map((tag, index) => (
                        <OnlineLessonTag key={`${tag}--${index}`} type={'course_group_tag'} text={tag} />
                    ))}
                </div>
                {canHide && (
                    <div className={'notification-card__header_close'}>
                        <AppFontIcon
                            icon={'collapse-s'}
                            onClick={handleCollapseBtnClick}
                            size={20}
                            color={E_COLORS.firm_blue_color}
                        />
                    </div>
                )}
            </div>
            <div className={`notification-card__title  ${isCollapsed && 'hidden'}`}>
                <AppText text={title} textStyle={'DesktopH3'} />
            </div>
            <div className={`notification-card__details ${isCollapsed && 'hidden'}`}>
                {users?.map((user) => {
                    const name = getUserName(
                        { name: user.firstName, surname: user.lastName, patronymic: user?.patronymic },
                        'NN:_:PP:_:SS',
                    );
                    return (
                        <div key={name} className={'notification-card__details_item'}>
                            <AppFontIcon icon={'user-s'} size={24} />
                            <AppText text={name} textStyle={'DesktopFontBody'} color={E_COLORS.main_dark_icons} />
                        </div>
                    );
                })}
                <div className={'notification-card__details_item'}>
                    <AppFontIcon icon={'book-s'} size={24} />
                    <AppText text={description} textStyle={'DesktopFontBody'} color={E_COLORS.main_dark_icons} />
                </div>
            </div>
            <div className={`enter-btn ${isCollapsed && 'hidden'}`}>
                <MeetingEnterButton url={url} />
            </div>
        </div>
    );
};
